var React = require('react');
import { checkFieldsForValidity } from './helpers/checkFieldsForValidity'

class OrderSubmitButton extends React.Component {

    constructor() {
        super();
        this.isOrderEmpty = this.isOrderEmpty.bind(this);
        this.displayIfEmpty = this.displayIfEmpty.bind(this);
        this.touchAllFields = this.touchAllFields.bind(this);
        this.anyFieldIsInvalid = this.anyFieldIsInvalid.bind(this);
    }

    isOrderEmpty() {
        let empty = true
        this.props.store.samples.forEach((s) => {
            if (s.checked) {
                empty = false
            }
        });
        if (this.props.store.other_options.water_chemistry.checked) {
            empty = false
        }
        return empty;
    }

    touchAllFields(){
        this.props.actions.touchAllFields();
    }

    displayIfEmpty() {
        if (this.isOrderEmpty()) {
            return (
                <div className='cannot-submit-empty-order margin-bottom-sm'>
                    Order is empty, select some options before submitting.
                </div>
            )
        }
    }

    anyFieldIsInvalid(){
        return !checkFieldsForValidity(this.props.store.fields);
    }

    onClick(e){
        if(this.anyFieldIsInvalid()) {
            e.preventDefault();
            this.props.actions.touchAllFields();
        }
    }

    render() {
        return (
            <div className="text-right">
                {this.displayIfEmpty()}
                <div>
                    <input disabled={this.isOrderEmpty()}
                           onClick={this.onClick.bind(this)}
                           id="create_order"
                           className={`submit float-right ${this.isOrderEmpty() ? 'disabled' : '' }`}
                           type="submit"
                           value="Create Order"/>
                </div>
            </div>
        );
    }
}

export default OrderSubmitButton